module.exports = __webpack_public_path__ + "static/img/logo_bodytone_top_main.972314e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo_bodytone_top_main.png
// module id = avx/
// module chunks = 1